import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Fade + rise on scroll into view
export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line heading. `lines` = array of strings.
export const MaskedLines = ({ lines, className = "", as: Tag = "h1", delay = 0 }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-mask">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, ease: EASE, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

// Word-stagger reveal for a single line
export const MaskedWords = ({ text, className = "", as: Tag = "h2", delay = 0 }) => {
  const words = text.split(" ");
  return (
    <Tag className={className}>
      {words.map((w, i) => (
        <span key={i} className="reveal-mask" style={{ display: "inline-block" }}>
          <motion.span
            className="inline-block"
            initial={{ y: "110%", opacity: 0 }}
            whileInView={{ y: "0%", opacity: 1 }}
            viewport={{ once: true, margin: "-40px", amount: 0.2 }}
            transition={{ duration: 0.7, ease: EASE, delay: delay + i * 0.05 }}
          >
            {w}&nbsp;
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

// Infinite marquee
export const Marquee = ({ children, fast = false, className = "" }) => (
  <div className={`flex overflow-hidden ${className}`}>
    <div className={`flex shrink-0 ${fast ? "animate-marquee-fast" : "animate-marquee"}`}>
      {children}
      {children}
    </div>
  </div>
);

export { EASE };
